<template>
  <div class="sevice">
    <img src="@/assets/images/sevice@2x.png" @click="toService" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toService() {
      window.open(
        "https://work.weixin.qq.com/kfid/kfcff55f4dc317ef5ee",
        "_blank"
      );
      // this.$router.push({name: 'OnlineService'})
    }
  }
};
</script>
<style lang="scss" scoped>
.sevice {
  img {
    width: 120px;
    height: 120px;
  }
}
</style>
